import React from 'react';
import { ApolloProvider, useQuery } from '@apollo/client';
import graphqlClient from '../graphqlClient';
import { TAX_CLIENT_DETAILS_QUERY } from '../../tax-web-app/queries';
import { TaxClientDetailsResponse } from '../../tax-web-app/types';

interface ClientTaxDetailsContentProps {
  clientId: string;
}

const ClientTaxDetailsContent: React.FC<ClientTaxDetailsContentProps> = ({ clientId }) => {
  const { data, loading, error } = useQuery<TaxClientDetailsResponse>(TAX_CLIENT_DETAILS_QUERY, {
    variables: { clientId },
    context: { useV2: true },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (loading && !data) return <div>Loading tax details...</div>;
  if (error && !data) return <div>Failed to load tax details.</div>;

  const taxClient = data?.taxClient;
  if (!taxClient) return null;

  const coordinator = taxClient.taxTeam.find(m => m.role === 'COORDINATOR');
  const advisor = taxClient.taxTeam.find(m => m.role === 'ADVISOR');

  return (
    <>
      <div className="bl-card_input-block">
        <div className="half">
          <div className="bl-input">
            <input
              id="tax-advisory-status"
              type="text"
              className="non-empty"
              value={taxClient.advisory ? 'Yes' : 'No'}
              readOnly
            />
            <label htmlFor="tax-advisory-status" {...({ placeholder: 'Advisory Status' } as any)} />
          </div>
        </div>
      </div>
      <div className="bl-card_input-block">
        <div className="half">
          <div className="bl-input">
            <input
              id="tax-coordinator"
              type="text"
              className="non-empty"
              value={coordinator?.person.fullName ?? '—'}
              readOnly
            />
            <label htmlFor="tax-coordinator" {...({ placeholder: 'Coordinator' } as any)} />
          </div>
        </div>
        <div className="half">
          <div className="bl-input">
            <input
              id="tax-advisor"
              type="text"
              className="non-empty"
              value={advisor?.person.fullName ?? '—'}
              readOnly
            />
            <label htmlFor="tax-advisor" {...({ placeholder: 'Advisor' } as any)} />
          </div>
        </div>
      </div>
    </>
  );
};

export const ClientTaxDetails: React.FC<{ clientId: string }> = ({ clientId }) => (
  <ApolloProvider client={graphqlClient}>
    <ClientTaxDetailsContent clientId={clientId} />
  </ApolloProvider>
);
